import React, { useEffect, useState } from "react";

const EocAlert = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const apiUrl = process.env.EMERGENCY_ALERT_SOURCE;

    const loadJSON = async () => {
      try {
        const response = await fetch(apiUrl);
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Failed to load JSON", error);
      }
    };

    loadJSON();
  }, []);

  return (
    <div>
      {data && data.status === true && (
        <div className="eoc-alert">
          <span className="eoc-alert-msg">{data.msg}</span>{" "}
          <a className="eoc-alert-btn" href={data.url}>
            READ MORE
          </a>
        </div>
      )}
    </div>
  );
};

export default EocAlert;